const STORAGE_KEY = 'sa_custom_policies';

function _read() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function _write(items) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
}

function getCustomPolicies() {
  return _read();
}

function saveCustomPolicy(policy) {
  const items = _read();
  const idx = items.findIndex((p) => p.id === policy.id);
  const entry = {
    ...policy,
    isCustom: true,
    updatedDate: new Date().toISOString(),
    createdDate: policy.createdDate || new Date().toISOString(),
  };
  if (idx >= 0) {
    items[idx] = entry;
  } else {
    items.unshift(entry);
  }
  _write(items);
  return entry;
}

function deleteCustomPolicy(id) {
  const items = _read().filter((p) => p.id !== id);
  _write(items);
}

const PolicyStorage = { getCustomPolicies, saveCustomPolicy, deleteCustomPolicy };
export default PolicyStorage;
